import { serverPostRequest } from '../../services/utilsServices';

const SSA_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_SYNDICATED_SPONSORED_ADS_SECURE }`;

export const getPublisherSSASuggestions = serverPostRequest(`${ SSA_SECURE_BASE_URL }syndication-publisher/autosuggest`);
export const getChannelSSASuggestions = serverPostRequest(`${ SSA_SECURE_BASE_URL }syndication-ad-channel/autosuggest`);
export const getAdUnitSSASuggestions = serverPostRequest(`${ SSA_SECURE_BASE_URL }syndication-ad-unit/autosuggest`);
